export default {"src":"/_next/static/media/wrrigly-up.98bd649d.svg","height":85,"width":80,"blurWidth":0,"blurHeight":0};